import { Card, Typography, Chip } from '@material-tailwind/react'
import { useSelector } from 'react-redux'

export const UserInfo = () => {
  const { current: currentUser } = useSelector(state => state.user)

  return (
    <Card className='flex items-start justify-between px-4 py-3 shadow-none'>
      <section className='flex w-full min-w-0 flex-col gap-1'>
        <Typography
          variant='paragraph'
          className='overflow-hidden text-sm font-semibold leading-tight text-gray-700 [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2]'
        >
          {currentUser?.name}
        </Typography>
        <details className='side-bar__tooltip'>
          <summary className='side-bar__tooltip-summary'>
            <Typography
              variant='paragraph'
              className='block w-full overflow-hidden text-ellipsis whitespace-nowrap text-xs font-normal text-gray-500'
            >
              {currentUser?.email}
            </Typography>
          </summary>
          <div className='side-bar__tooltip-content'>
            {currentUser?.email}
          </div>
        </details>
        <div>
          {(currentUser?.roles || []).map(role => (
            <Chip
              key={role.id}
              className='w-fit rounded-full text-slate-700 text-xs font-medium normal-case bg-gray-100'
              size='sm'
              value={role.nameText}
            />
          ))}
        </div>
      </section>
    </Card>
  )
}
